module.exports = __webpack_public_path__ + "img/placeholder-horizontal-yellow.fce9484f.svg";